import { render, staticRenderFns } from "./WebsiteArticleModal.vue?vue&type=template&id=13edab20&"
import script from "./WebsiteArticleModal.vue?vue&type=script&lang=js&"
export * from "./WebsiteArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports